import { Link, useNavigate } from "react-router-dom";
import { FaLocationDot, FaPhone } from "react-icons/fa6";
import { MdMarkEmailRead } from "react-icons/md";
import Section from "./Section";
import { useDispatch } from "react-redux";
import { delayNavigation } from "../helpers/helpers";
import { Projects } from "../Data/Data";
import LogoSVG from "./SVG/LogoSVG";

const Footer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Section bg="bg-transparent">
      <footer className="col-span-10 col-start-2 grid grid-cols-7 gap-6 text-primary-dark text-2xl tracking-wide font-medium pt-8 pb-16 border-t-2 border-primary-dark/30">
        <div className="hidden col-span-4 xl:grid grid-cols-3 gap-12  border-r-2 pr-10 border-primary-dark/50 text-primary-bg-blue md:text-xl font-normal tracking-widest ">
          <div className="xl">
            <h2 className="font-gilroy text-2xl tracking-normal relative mb-4">
              ბიზნესი
            </h2>
            <ul className="list-none flex flex-col items-start justify-start gap-3 ">
              <li className="relative group">
                <Link
                  onClick={(event) => {
                    delayNavigation(dispatch, navigate, "/", event);
                  }}
                >
                  მთავარი გვერდი
                </Link>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>
              <li className="relative group">
                <Link
                  onClick={(event) => {
                    delayNavigation(dispatch, navigate, "/about", event);
                  }}
                >
                  K2 Invest
                </Link>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>

              <li className="relative group">
                <Link
                  onClick={(event) => {
                    delayNavigation(dispatch, navigate, "/projects", event);
                  }}
                >
                  პროექტები
                </Link>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>
              <li className="relative group">
                <Link
                  onClick={(event) => {
                    delayNavigation(dispatch, navigate, "/news", event);
                  }}
                >
                  სიახლეები
                </Link>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>
            </ul>
          </div>
          <div>
            <h2 className="font-gilroy text-2xl tracking-normal relative mb-4">
              პროექტები
            </h2>
            {Projects.map((project) => (
              <>
                <ul className="list-none flex flex-col items-start justify-start gap-1 text-base mb-4">
                  <li className="relative group ">
                    <Link
                      className="whitespace-nowrap overflow-hidden text-ellipsis flex items-center justify-start gap-2"
                      onClick={(event) => {
                        delayNavigation(
                          dispatch,
                          navigate,
                          `/projects/${project.name}`,
                          event
                        );
                      }}
                    >
                      <LogoSVG w={25} h={15} /> {project.label.split(" ")[1]}
                    </Link>
                    <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
                  </li>
                  <li className="relative group">
                    <Link
                      onClick={(event) => {
                        delayNavigation(
                          dispatch,
                          navigate,
                          "/projects/greenhome/apartments",
                          event
                        );
                      }}
                    >
                      ბინები
                    </Link>
                    <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
                  </li>
                </ul>
              </>
            ))}
            {/* <ul className="list-none flex flex-col items-start justify-start gap-3 text-base">
              <li className="relative group">
                <Link
                  onClick={(event) => {
                    delayNavigation(
                      dispatch,
                      navigate,
                      "/projects/greenhome",
                      event
                    );
                  }}
                >
                  K2 ავტომშენებელზე
                </Link>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full "></span>
              </li>
              <li className="relative group">
                <Link
                  onClick={(event) => {
                    delayNavigation(
                      dispatch,
                      navigate,
                      "/projects/greenhome/apartments",
                      event
                    );
                  }}
                >
                  ბინები
                </Link>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>
            </ul> */}
          </div>
          <div>
            <h2 className="font-gilroy text-2xl tracking-normal relative mb-4 ">
              სხვა
            </h2>
            <ul className="list-none flex flex-col items-start justify-start gap-3 font-light">
              <li className="relative group cursor-pointer">
                <a href="blank" to={""}>Facebook</a>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>
              <li className="relative group cursor-pointer">
                <a href="blank" to={""}>Instagram</a>
                <span className="absolute bottom-0 left-0 w-0 h-[3px] bg-primary-dark transition-all duration-500 group-hover:w-full"></span>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-span-full xl:col-span-3 flex flex-col gap-4 items-start justify-start text-primary-bg-blue md:text-xl tracking-widest text-wrap">
          <h2 className="font-gilroy tracking-normal relative">კონტაქტი</h2>
          <div className="flex w-full items-start text-base">
            <FaLocationDot className="w-5 h-5 mt-1 mr-2" />

            <div className="w-full">
              <p className="block text-base ">
                ქ.ქუთაისი ზ.ჭავჭავაძის ქუჩა N2ა
              </p>
              <a
                href="https://maps.app.goo.gl/Q3G76FbHeKJMNnN48"
                className="text-[#b63a32] inline-block text-[13px] leading-none mb-[13px]"
                target="_blank"
                rel="noreferrer"
              >
                ლოკაცია
              </a>
            </div>
          </div>
          <div className="flex w-full items-start text-base">
            <FaLocationDot className="w-5 h-5 mt-1 mr-2" />

            <div className="w-full">
              <p className="block text-base ">
                ქ.ქუთაისი ნიკეას ქუჩა, I შეს. N1
              </p>
              <a
                href="https://www.google.com/maps/@42.2460016,42.6932154,114m/data=!3m1!1e3?authuser=0&entry=ttu&g_ep=EgoyMDI2MDMwMi4wIKXMDSoASAFQAw%3D%3D"
                className="text-[#b63a32] inline-block text-[13px] leading-none mb-[13px]"
                target="_blank"
                rel="noreferrer"
              >
                ლოკაცია
              </a>
            </div>
          </div>
          <div className="flex items-center w-full text-base">
            <MdMarkEmailRead className="w-5 h-5 mr-2" />
            <div className="w-full">
              <div>
                <p className="block text-base">k2investsales@gmail.com</p>
              </div>
            </div>
          </div>
          <div className="flex items-center w-full font-light text-base">
            <FaPhone className="w-4 h-4 mr-2" />
            <div id="w-node-_93146bfe-efa2-a64c-b143-40bdc919440b-c91943af">
              <p className="block text-base">+995 500 10 30 30</p>
            </div>
          </div>
          <div className="flex items-center w-full font-light text-base">
            <FaPhone className="w-4 h-4 mr-2" />
            <div id="w-node-_93146bfe-efa2-a64c-b143-40bdc919440b-c91943af">
              <p className="block text-base">+995 501 33 30 30</p>
            </div>
          </div>
        </div>
      </footer>
    </Section>
  );
};

export default Footer;
